import { config } from 'src/config';
import { isServer } from 'src/shared/utils/environment';

interface DefaultPageActionAttrs {
  release?: string;
  appVersion?: string;
  deviceOs?: string;
  deviceOsVersion?: string;
}

const EventType = {
  BUILDING_FULLY_LOADED: 'BuildingLoaded',
  RUNTIME_ERROR: 'RuntimeError',
  GEOMETRY_AND_METADATA_LOADED: 'GeometryAndMetadataLoaded',
  TEXTURES_APPLIED: 'TexturesApplied',
  LOAD_BUILDING_STARTED: 'LoadBuildingStarted',
  UNTEXTURED_BUILDING_LOADED: 'UntexturedBuildingLoaded',
  FETCHING_LATEST_VERSION_DONE: 'FetchingLatestVersionDone',
  DEFAULT_STYLES_APPLIED: 'DefaultStylesApplied',
  SAVED_USER_STYLES_APPLIED: 'SavedUserStylesApplied',
  DESIGNER_ORIGINAL_IMAGE_UPLOADED: 'DesignerOriginalImageUploaded',
  DESIGNER_GENERATED_IMAGE_NEW: 'DesignerGeneratedImageNew',
  DESIGNER_GENERATED_IMAGE_RECEIVED: 'DesignerGeneratedImageReceived',
  DESIGNER_GENERATED_IMAGE_FAILED: 'DesignerGeneratedImageFailed',
};

const buildDefaultAttrs = () => {
  const defaultAttrs: DefaultPageActionAttrs = {
    release: config.APP_VERSION,
  };
  if (!isServer()) {
    const appMeta = window.HOVERApp;
    if (appMeta) {
      defaultAttrs.appVersion = appMeta.version;
      defaultAttrs.deviceOs = appMeta.platform.name;
      defaultAttrs.deviceOsVersion = appMeta.platform.version;
    }
  }
  return defaultAttrs;
};

interface IEmitPageActionAttrs {
  aiOriginalImageId?: string;
  aiGeneratedImageId?: string;
  designStudioMode?: string;
}

const emitPageAction = (
  actionName: (typeof EventType)[keyof typeof EventType],
  attrs: IEmitPageActionAttrs,
) => {
  const defaultAttrs = buildDefaultAttrs();
  if (window.newrelic) {
    window.newrelic.addPageAction(actionName, { ...defaultAttrs, ...attrs });
  }
};

export { emitPageAction, EventType };
